import { IGetAllCustomProductOptionConfigsBodyRes } from "@evennt-tech/api-v2-external";
import {
  CustomProductOptionConfigType,
  ICustomProductOptionConfig,
} from "@evennt-tech/api-v2-core";
import { parseCents } from "tools/product/formats/formatCents";

export const getDefaultCpoConfig = <T extends ICustomProductOptionConfig>(
  cpoConfigs: T[]
) => {
  if (!cpoConfigs?.length) {
    return;
  }
  const defaultCpoConfig = cpoConfigs.find(
    ({ type }) => type === CustomProductOptionConfigType.DEFAULT
  );

  return defaultCpoConfig;
};

export const getDefaultCpoConfigOrFirst = <
  T extends ICustomProductOptionConfig
>(
  cpoConfigs?: T[]
): T | undefined => getDefaultCpoConfig(cpoConfigs ?? []) ?? cpoConfigs?.[0];

export const filterCustomCpoConfigs = (
  cpoConfigs: IGetAllCustomProductOptionConfigsBodyRes[]
) =>
  cpoConfigs.filter(
    ({ type }) => type === CustomProductOptionConfigType.CUSTOM
  );

export const parseCpoConfig = <T extends { priceUplift: number }>(
  config: T
): T => ({
  ...config,
  priceUplift: parseCents(config.priceUplift ?? 0),
});
